import { useRef, useCallback, useState } from 'react';
import { InternalTooltip } from 'react-rainbow-components';

interface TooltipWrapperProps {
    children: React.ReactNode;
    tooltipLabel?: string;
}

const TooltipWrapper = ({ children, tooltipLabel }: TooltipWrapperProps) => {
    const triggerRef = useRef<HTMLDivElement>(null);
    const tooltipRef = useRef();
    const [isVisible, setIsVisible] = useState(false);

    const handleMouseEnter = useCallback(() => {
        if (triggerRef.current) {
            setIsVisible(true);
        }
    }, []);

    const handleMouseLeave = useCallback(() => {
        setIsVisible(false);
    }, []);

    const handleBlur = useCallback(() => {
        setIsVisible(false);
    }, []);

    const getTriggerElement = useCallback(() => triggerRef, []);

    if (!tooltipLabel) {
        return children;
    }

    return (
        <div
            ref={triggerRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onBlur={handleBlur}
        >
            {children}
            <InternalTooltip
                triggerElementRef={getTriggerElement}
                ref={tooltipRef}
                preferredPosition="top"
                isVisible={isVisible}
            >
                {tooltipLabel}
            </InternalTooltip>
        </div>
    );
};

export default TooltipWrapper;
